import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { DBDoc, ModelSearch, SearchType } from '@fry/lib/store';
import { SearchStore } from '@fry/lib/store/search.store';

import { BookingOption } from './booking-option';
import { BookingItemsStore } from './booking-items.store';
import { BookingItem } from './booking-item';


@Injectable({
  providedIn: 'root'
})
export class BookingOptionsStore extends SearchStore<BookingOption, DBDoc> {
  AssociatedModel = BookingOption;

  searchType = SearchType.LOCAL;

  data: BookingOption[] = [];

  public searchParameters: any;

  public breadcrumbs: (BookingItem|BookingOption)[] = [];

  constructor(private bookingItems: BookingItemsStore) {
    super();
  }

  loadAvailableFor(username: string, path: string[] = [], strict: boolean = false) {
    const innerFltr = {
      path,
      strict
    };
    return this.bookingItems.getAvailableOptionsHierarchy(username, innerFltr).pipe(
      tap(options => {
        this.data = options.hits.map(itm => this.createObject(itm));
      })
    );
  }

  reset()  {
    this.data = [];
  }

  search(params: any, options: { strict?: boolean } = {}): Observable<ModelSearch<BookingOption>> {
    const strict = options && options.strict ? options.strict : false;
    let result: ModelSearch<BookingOption> = {
      data: this.data, meta: { total: 0 }
    };

    if (this.data.length !== 0) { return of(result); }

    const parameters = params['user'] && params['path']
                       ? params
                       : this.searchParameters;
    if (!parameters) { return of(result); }

    return this.loadAvailableFor(parameters.user, parameters.path, strict).pipe(
      map(() => {
        const result: ModelSearch<BookingOption> = {
          data: this.data, meta: { total: 0 }
        };
        return result;
      })
    );
  }

  table(params: any) {
    return this.bookingItems.getAvailableOptionsTable(params);
  }

  export(_params: any) {
    return of({});
  }

  startExport(_params: any) {
    return of({});
  }

  get(boid, bid) {
    return this.bookingItems.getBookableOption(boid, bid).pipe(
      map(doc => this.createObject(doc))
    );
  }

  get_capacity_info(boid, bid) {
    return this.bookingItems.getCapacityInfo(boid, bid).pipe(
    );
  }
}
